import { combineReducers } from "redux";
import LoginWidget from "./LoginWidget";

const LoginReducer = combineReducers({
  LoginWidget: LoginWidget,
});

export default LoginReducer;
